import React, { useState, useEffect, useContext } from 'react';
import { Table, Card, Button, Modal } from 'react-bootstrap';
import { getFromAPI, deleteFromAPI, showAlert, putToAPI, formatDate } from '../../Utils/utils';
import { toast, ToastContainer } from "react-toastify";
import { VendorContext1 } from './vendorContext';
import { useVendor, CustomerProvider } from './getVendor'; // Import the useCustomer hook

// icon
import Icon from '@mdi/react';
import { mdiSquareEditOutline, mdiTrashCanOutline, mdiPhoneInTalk, mdiMessageProcessing, mdiEmail } from '@mdi/js';
import FormModal from '../../Utils/FormModal';
import messages from '../../Utils/lang'
export default function Details({ setselectedVendorId }) {
    const selectedCustomerId = useContext(VendorContext1);
    const { vendor, fetchVendorData } = useVendor();
    const [stateName, setStateName] = useState();
    const [State, setState] = useState([]);
    //const [stateCode, setStateCode] = useState();
    const [city, setCity] = useState([]);
    const [Tax, setTax1] = useState([]);
    const [phoneShow, setPhoneShow] = useState(false);
    const [msgShow, setMsgShow] = useState(false);
    const [cityName, setCityName] = useState();
    const [emailShow, setEmailShow] = useState(false);
    const [contactPerson, setContactPerson] = useState();
    const [mobileNo, setMobileNo] = useState();
    const [email, setEmail] = useState();
    const [website, setWebsite] = useState();
    const [address, setAddress] = useState();
    const [Country, setCountry] = useState();
    const [tax, setTax] = useState();
    const [gst, setGst] = useState();
    const [pan, setPan] = useState();
    const [openingBalance, setOpeningBalance] = useState();
    const [Alternate, setAlternate] = useState();
    const [bank, setBank] = useState();
    const [IFSC, setIFSC] = useState();
    const [AccNo, setAccNo] = useState();
    const [Bank, setBank1] = useState([]);
    const [country, setCountry1] = useState([]);
    const [comapnyName, setCompanyName] = useState('');
    const [taxName, setTaxName] = useState();
    const [vendorTax, setVendorTax] = useState();
    const [vendorTaxType, setVendorTaxType] = useState();
    const [created_date, setcreated_date] = useState();

    // Edit vendor modal
    const [formModalShow, setShowFormModal] = useState(false);
    const handleVdEdit = () => setShowFormModal(true);
    const handleFormModalClose = () => setShowFormModal(false);
    const handleCloseModal = () => {
        setShowFormModal(false);
    };
    const [inputData, setInputData] = useState({
        name: '',
        company_name: null,
        phone_number1: '',
        email: '',
        gst_number: null,
        country: 0,
        state: 0,
        city: 0,
        tax: 0,
        pan_card_number: null,
        opening_balance: 0.0,
        bank_branch_name: null,
        bank_branch_ifsc_code: null,
        bank_account_number: 0,
        website: null,
        phone_number2: null,
        primary_address: null,
        tax_type: 1,
        tax_id: 1,
    })

    // Add new state for tax options
    const [taxOptions] = useState([
        { id: 1, name: 'B2C', code: 'b2c' },
        { id: 2, name: 'B2B', code: 'b2b' },
        { id: 3, name: 'B2B-IGST', code: 'b2b-igst' },
        { id: 4, name: 'B2C-IGST', code: 'b2c-igst' }
    ]);
    
    const [taxOption2] = useState([
        { id: 1, name: 'Regular Tax', code: 'regular' },
        { id: 2, name: 'Composite Tax', code: 'composite' },
        { id: 3, name: 'No Tax', code: 'no' }
    ]);
    
    const [taxTypeOptions] = useState([
        { id: 1, name: 'Exculsive', code: 'exculsive' },
        { id: 2, name: 'Inclusive', code: 'inclusive' },
    ]);
    
    const getVendorTax = (taxID) => {
        const taxOption = taxOption2.find(option => option.id === taxID);
        return taxOption ? taxOption.name : "Exculsive";
    }
    
    const getTaxType = (taxID) => {
        const taxOption = taxTypeOptions.find(option => option.id === taxID);
        return taxOption ? taxOption.name : "Regular Tax";
    }
    
    // Add this helper function to map tax ID to name
    const getTaxNameById = (taxID) => {
        const taxOption = taxOptions.find(option => option.id === taxID);
        return taxOption ? taxOption.name : "NA";
    };
    
    let response = '';
    const fetchVendorFormData = async () => {
        try {
            // Check if selectedCustomerId is available
            if (!selectedCustomerId) {
                // Clear the form data if no ID is selected
                setContactPerson('');
                setMobileNo('');
                setEmail('');
                setAddress('');
                setCountry('');
                setGst('');
                setTax('');
                setPan('');
                setOpeningBalance('');
                setBank('');
                setIFSC('');
                setAccNo('');
                setWebsite('');
                setAlternate('');
                setCityName('');
                setStateName('');
                setTaxName('');
                setVendorTax('');
                setVendorTaxType('');
                return; // Return early, do not proceed with API call
            }
    
            // Proceed with API call if selectedCustomerId is valid
            const response = await getFromAPI(`FtsVendor/?id=${selectedCustomerId}`);
    
            if (response && response.length > 0) {
                // Fetch vendor data
                const company_name = response[0].company_name
                setCompanyName(company_name)
                const contact_name = response[0].name;
                setContactPerson(contact_name);
                const mobile = response[0].phone_number1;
                setMobileNo(mobile);

                const email = response[0].email;
                setEmail(email);
    
                const address = response[0].primary_address;
                setAddress(address);
    
                let country = response[0].country;
                const countryName = await getCountryName(country);
                setCountry(countryName);
    
                const gst = response[0].gst_number;
                setGst(gst);
    
                const Tax = response[0].tax;
                const taxName = await gettaxById(Tax);
                setTax(taxName);
    
                const pan = response[0].pan_card_number;
                setPan(pan);
    
                const opening_balance = response[0].opening_balance;
                setOpeningBalance(opening_balance);
    
                const Bank_Name = await getBankByName(response[0].bank_branch_name);
                setBank(Bank_Name);
    
                const IFSC_CODE = response[0].bank_branch_ifsc_code;
                setIFSC(IFSC_CODE);
    
                const accNo = response[0].bank_account_number;
                setAccNo(accNo);
    
                const web = response[0].website;
                setWebsite(web);
    
                const alt = response[0].phone_number2;
                setAlternate(alt);
    
                const tax = getTaxNameById(response[0].tax);
                setTaxName(tax)
    
                const vendorTax = getVendorTax(response[0].tax_id);
                setVendorTax(vendorTax)
    
                const vendorTaxType = getTaxType(response[0].tax_type);
                setVendorTaxType(vendorTaxType)
    
                const stateCode = response[0].state; // Assuming state contains the state_code
                const cityID = response[0].city; // Assuming city contains the id
    
                // Fetch state and city names
                const stateName = await getStateNameByCode(stateCode);
                const cityName = await getCityByName(cityID);
                setCityName(cityName);
                setStateName(stateName);
    
                // Assuming response[0].created_date_time is "2024-10-21T16:31:48Z"
                const dateTimeString = response[0].created_date_time;
                const date = dateTimeString.split('T')[0]; // Extracts the date part before 'T'
                setcreated_date(formatDate(date)); // Sets the extracted date
            } else {
                return null;
            }
        } catch (error) {
            return null;
        }
    };
    

    useEffect(() => {
        const fetchCustomerDetails = async () => {
            try {
                const response = await getFromAPI(`FtsVendor/?id=${selectedCustomerId}`);
                if (response && response.length > 0) {
                    const vendorData = response[0];
                    const stateName1 = await getStateNameByCode(vendorData.state);
                    const cityName = await getCityByName(vendorData.city);
                    const callingCode = vendorData.country
                    const countryName = await getCountryName(callingCode);

                    setInputData({
                        name: vendorData.name,
                        company_name: vendorData.company_name || '',
                        phone_number1: vendorData.phone_number1 || '',
                        email: vendorData.email || '',
                        primary_address: vendorData.primary_address || '',
                        gst_number: vendorData.gst_number || '',
                        country: vendorData.country,
                        state: vendorData.state,
                        city: vendorData.city,
                        tax: vendorData.tax,
                        pan_card_number: vendorData.pan_card_number || '',
                        opening_balance: vendorData.opening_balance,
                        bank_branch_name: vendorData.bank_branch_name || '',
                        bank_branch_ifsc_code: vendorData.bank_branch_ifsc_code || '',
                        bank_account_number: vendorData.bank_account_number || '',
                        website: vendorData.website || '',
                        phone_number2: vendorData.phone_number2 || '',
                        tax_id: vendorData.tax_id || '',
                        tax_type: vendorData.tax_type || '',

                    });
                    // Fetch state based on country
                    if (vendorData.country) {
                        const stateResponse = await getFromAPI(`FtsState/?country_code=${vendorData.country}`);
                        setState(stateResponse); // Set state dropdown
                    }

                    // Fetch city based on state
                    if (vendorData.state) {
                        const cityResponse = await getFromAPI(`FtsCity/?state_id=${vendorData.state}`);
                        setCity(cityResponse); // Set city dropdown
                    }
                }
            } catch (error) {
                return null;
            }
        };

        if (selectedCustomerId) {
            fetchCustomerDetails();
        }
    }, [selectedCustomerId]);


    const getBankByName = async (id) => {
        if (!id) return null;
        try {
            const bankResponse = await getFromAPI(`FtsBanks/?bank_id=${id}`);
            if (bankResponse) {
                return bankResponse[0].bank_name; // Return the state name
            }
            else {
                return null;
            }
        } catch (error) {
            return null; // Return null in case of an error
        }
    };

    // Handle input specifically for Mobile Number and Email
    const handleMobileChange = (e) => {
        const { name, value } = e.target;
        // Remove spaces from the input value
        setInputData((prev) => ({
            ...prev,
            [name]: value.replace(/\s+/g, ''), // Remove all spaces
        }));
    };

    const handleCountryChange = async (e) => {
        const selectedCountry = e.target.value;
        setInputData(prevState => ({ ...prevState, country: selectedCountry }));

        try {
            const response = await getFromAPI(`FtsState/?country_code=${selectedCountry}`);
            setState(response); // Save state data
            setCity([]); // Reset city data
        } catch (error) {
            return null;
        }
    };

    const handleStateChange = async (e) => {
        const selectedState = e.target.value;
        setInputData(prevState => ({ ...prevState, state: selectedState }));

        try {
            const response = await getFromAPI(`FtsCity/?state_id=${selectedState}`);
            setCity(response); // Save city data
        } catch (error) {
            return null;
        }
    };

    const handleDeleteVendor = async (itemId) => {
        if (!itemId) return;
        try {
            const response = await deleteFromAPI(`FtsVendor/${itemId}/`);
            if (response.status) {
                toast.success('Vendor deleted successfully', 'success');
                // Optionally, redirect or update state to reflect deletion
                fetchVendorData();
                fetchVendorFormData();

                if (vendor.length > 1) {
                    setselectedVendorId(vendor[0].id)
                }
                else {
                    setselectedVendorId('')
                }
            }
        } catch (error) {
            toast.error('Vendor Not Deleted', 'error');
        }

    };

    // Handle Delete vendor Entry
    const handleDeleteVendorEntry = async (Id) => {
        if (!Id) return;
        // TODO: Check vendor has transactions or invoices before deleting
        const POInvoiceData = await getFromAPI(`FtsPurchaseOrderInvoice/?vendor=${Id}`);
        // const POCreditNote = await getFromAPI(`FtsPurchaseOrderCreditNote/?vendor=${Id}`);
        if (POInvoiceData.length === 0) {
            try {
                showAlert('Are you sure you want to delete this Vendor?', 'confirm', (result) => {
                    if (result) {
                        // User confirmed the deletion
                        handleDeleteVendor(Id);
                    } else {
                        // User canceled the deletion
                        // You can handle this case if needed
                    }
                });
            } catch (error) {
                toast.error('Error deleting Customer', 'error');
            }
        } else {
            toast.error('Vendor has transactions or invoices. Cannot delete.', 'error');
        }
    };

    // function for get the state name by state code
    const getStateNameByCode = async (code) => {
        if (!code) return;
        try {
            const stateResponse = await getFromAPI(`FtsState/`);

            // Assuming stateResponse is an array of states
            const state = stateResponse.find(state => state.state_id === code); // Replace `id` with the actual key for state ID in your response
            if (state) {
                return state.state_name; // Return the state name
            } else {
                return null; // Return null if not found
            }
        } catch (error) {
            return null; // Return null in case of an error
        }
    };

    // function for get the city by name
    const getCityByName = async (code) => {
        if (!code) return; // Return early if code is not provided
        try {
            const CityResponse = await getFromAPI(`FtsCity/?id=${code}`);

            if (CityResponse) {
                return CityResponse[0].city_name; // Return the state name
            } else {
                return null; // Return null if not found
            }
        } catch (error) {
            return null; // Return null in case of an error
        }
    };

    // function for get the country name
    const getCountryName = async (code) => {
        if (!code) return null;
        try {
            const countryResponse = await getFromAPI(`FtsCountries/?calling_code=${code}`);
            if (countryResponse) {
                return countryResponse[0].short_name; // Return the state name
            } else {
                return null; // Return null if not found
            }
        } catch (error) {
            return null; // Return null in case of an error
        }
    };

    const gettaxById = async (id) => {
        if (!id) return null;
        try {
            const taxResponse = await getFromAPI(`FtsTaxes/?id=${id}`);
            if (taxResponse) {
                return taxResponse[0].name; // Return the state name
            }
            else {
                return null;
            }
        } catch (error) {
            return null; // Return null in case of an error
        }
    };

    useEffect(() => {
    const fetchBankData = async () => {
            try {
                const response = await getFromAPI('FtsBanks/');
                setBank1(response); // Save tax data
            } catch (error) {
                return null;
            }
        };

        fetchBankData();
    }, []);

    useEffect(() => {
        const fetchTaxData = async () => {
            try {
                const response = await getFromAPI('FtsTaxes/');
                setTax1(response); // Save tax data
            } catch (error) {
                return null;
            }
        };

        fetchTaxData();
    }, []);

    useEffect(() => {
        const fetchCountryData = async () => {
            try {
                const response = await getFromAPI("FtsCountries/");
                setCountry1(response); // Save country data
            } catch (error) {
                return null;
            }
        };

        fetchCountryData();
    }, []);


    const handleSaveChanges = async () => {
        // Check if company name is provided
        if (!inputData.company_name || !inputData.company_name.trim()) {
            toast.error(messages.vendor.company_name_required, 'error');
            return;
        }

        // Validate phone number 1
        if (!inputData.phone_number1 || inputData.phone_number1.length !== 10) {
            toast.error(messages.vendor.phone_number_required, 'error');
            return;
        }

        const isExists = Array.isArray(vendor) && vendor.find(v =>
            v.phone_number1.trim() === inputData.phone_number1.trim() &&
            v.id !== selectedCustomerId // Exclude the current branch being edited
        );

        if (isExists) {
            toast.error(messages.vendor.already_exist);
            return;
        }

        if (inputData.email) {
            const isExists = Array.isArray(vendor) && vendor.find(v =>
                v.email === inputData.email.trim() &&
                v.id !== selectedCustomerId // Exclude the current branch being edited
            );

            if (isExists) {
                toast.error(messages.vendor.already_email_exist);
                return;
            }
        }
        try {
            const formattedInputData = {
                ...inputData,
                tax_id: parseInt(inputData.tax_id, 10) || 1, // Set to 1 if null or invalid
                tax_type: parseInt(inputData.tax_type, 10) || 1, // Set to 1 if null or invalid
            };

            await putToAPI(`FtsVendor/${selectedCustomerId}/`, formattedInputData);
            toast.success('Vendor details updated successfully', 'success');
            setShowFormModal(false);
            fetchVendorData();
            fetchVendorFormData();
        } catch (error) {
            toast.error('Failed to update vendor details', 'error');
        }
    };


    useEffect(() => {
        fetchVendorFormData();
        fetchVendorData();
    }, [selectedCustomerId]);

    const handleInputChange = (index, field, value) => {
        if (field === 'gst_number') {
            handleGSTChange(value); // Pass the new GST value to handleGSTChange
        }
        setInputData({ ...inputData, [field]: value });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setShowFormModal(false);
    };

    const handleGSTChange = async (gstValue) => {

        if (!gstValue) return null;

        setInputData(prevState => ({ ...prevState, gst_number: gstValue }));

        if (gstValue.length >= 15) { // Standard GST number length is 15
            const stateCode = gstValue.substring(0, 2);
            const panNumber = gstValue.substring(2, 12);

            // Update PAN automatically
            setInputData(prevState => ({
                ...prevState,
                pan_card_number: panNumber
            }));

            try {
                // First get the country code for India (assuming GST is Indian)
                const countryResponse = await getFromAPI('FtsCountries/?calling_code=91');
                if (countryResponse.length > 0) {
                    const countryCode = countryResponse[0].calling_code;

                    // Set country to India
                    setInputData(prevState => ({
                        ...prevState,
                        country: countryCode
                    }));

                    // Fetch state data using the state code from GST
                    const stateResponse = await getFromAPI(`FtsState/?state_id=${stateCode}`);
                    if (stateResponse.length > 0) {
                        const stateData = stateResponse[0];
                        // Update tax based on GST state code

                        // Update state
                        setInputData(prevState => ({
                            ...prevState,
                            state: stateData.state_id,
                            pan_card_number: panNumber,
                            tax_id: 1,
                            tax_type: 2
                        }));

                        // Fetch and set cities for the selected state
                        const cityResponse = await getFromAPI(`FtsCity/?state_id=${stateData.state_code}`);
                        setCity(cityResponse);
                        // Set the first city as default if cities are available
                        if (cityResponse && cityResponse.length > 0) {
                            setInputData(prevState => ({
                                ...prevState,
                                city: cityResponse[0].id
                            }));
                        }
                    }
                }
            } catch (error) {
                toast.error('Error processing GST number');
            }
        }
    };


    const rows = [
        {
            columns: [
                { size: { xl: 4 }, label: (<>Customer Name <span className='text-danger'>*</span></>), type: 'text', name: 'company_name', id: 'company_name', placeholder: 'Enter company name...', value: inputData.company_name, onChange: e => setInputData({ ...inputData, company_name: e.target.value }), errormsg: '', },
                { size: { lg: 6, xl: 4 }, label: (<>Contact Person</>), type: 'text', name: 'name', id: 'contactPerson', placeholder: 'Enter contact person...', value: inputData.name, onChange: e => setInputData({ ...inputData, name: e.target.value }), errormsg: '', },
                { size: { lg: 6, xl: 4 }, label: (<>Mobile Number <span className='text-danger'>*</span></>), type: 'number', name: 'phone_number1', id: 'phone_number1', placeholder: 'Enter mobile number...', value: inputData.phone_number1, onChange: handleMobileChange, errormsg: '', },
                { size: { xl: 5 }, label: (<>Email</>), type: 'email', name: 'email', id: 'contactPerson', placeholder: 'Enter email...', value: inputData.email, onChange: e => setInputData({ ...inputData, email: e.target.value }), errormsg: '', },
                { size: { xl: 7 }, label: 'Address', type: 'text', name: 'primary_address', id: 'primary_address', placeholder: 'Enter your address...', value: inputData.primary_address, onChange: e => setInputData({ ...inputData, primary_address: e.target.value }), errormsg: '', },
                { size: { xl: 3 }, label: 'GST', type: 'text', name: 'gst_number', id: 'gst_number', placeholder: 'Enter GST...', value: inputData.gst_number, onChange: e => setInputData({ ...inputData, gst_number: e.target.value }), errormsg: '', },
                {
                    size: { lg: 4, xl: 3 }, label: 'Country', type: 'select', name: 'country', id: 'country', value: inputData.country, onChange: handleCountryChange, errormsg: '',
                    options: [
                        { value: '', label: 'Select Country' },
                        ...country.map(item => ({ value: item.calling_code, label: item.short_name }))
                    ],
                },
                {
                    size: { lg: 4, xl: 3 }, label: 'State', type: 'select', name: 'state', id: 'state', value: inputData.state, onChange: handleStateChange, errormsg: '',
                    options: [
                        { value: '', label: 'Select State' },
                        ...State.map(item => ({ value: item.state_id, label: item.state_name }))
                    ],
                },
                {
                    size: { lg: 4, xl: 3 }, label: 'City', type: 'select', name: 'city', id: 'city', value: inputData.city, onChange: e => setInputData({ ...inputData, city: e.target.value }), errormsg: '',
                    options: [
                        { value: '', label: 'Select City' },
                        ...city.map(item => ({ value: item.id, label: item.city_name }))
                    ],
                },
                {
                    size: { lg: 3 }, label: 'Tax', type: 'select', name: 'tax', id: 'tax', value: inputData.tax, onChange: e => setInputData({ ...inputData, tax: e.target.value }), errormsg: '',
                    options: [
                        { value: '', label: 'Select Tax' },
                        ...taxOptions.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { lg: 3 }, label: 'Vendor Tax', type: 'select', name: 'tax_id', id: 'tax_id', value: inputData.tax_id, onChange: e => setInputData({ ...inputData, tax_id: e.target.value }), errormsg: '',
                    options: [
                        ...taxOption2.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { lg: 3 }, label: 'Tax Type', type: 'select', name: 'tax_type', id: 'tax_type', value: inputData.tax_type, onChange: e => setInputData({ ...inputData, tax_type: e.target.value }), errormsg: '',
                    options: [
                        ...taxTypeOptions.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                { size: { lg: 5 }, label: 'PAN', aditionalClass: 'text-up', type: 'text', name: 'pan_card_number', id: 'panNumber', placeholder: 'Enter PAN number...', value: inputData.pan_card_number, onChange: e => setInputData({ ...inputData, pan_card_number: e.target.value }), errormsg: '', },
                { size: { lg: 4 }, label: 'Opening Balance', type: 'text', name: 'opening_balance', id: 'openingBalance', placeholder: 'Enter balance...', value: inputData.opening_balance, onChange: e => setInputData({ ...inputData, opening_balance: e.target.value }), errormsg: '', },
                { size: { lg: 8 }, label: 'Website', type: 'text', name: 'website', id: 'website', placeholder: 'Enter your website...', value: inputData.website, onChange: e => setInputData({ ...inputData, website: e.target.value }), errormsg: '', },
                { size: { lg: 4 }, label: 'Alternate Number', type: 'number', name: 'phone_number2', id: 'alternateNumber', placeholder: 'Enter alternate number...', value: inputData.phone_number2, onChange: e => setInputData({ ...inputData, phone_number2: e.target.value }), errormsg: '', },
                {
                    size: { lg: 4 }, label: 'Bank Name', type: 'select', name: 'bank_branch_name', id: 'tax', value: inputData.bank_branch_name, onChange: e => setInputData({ ...inputData, bank_branch_name: e.target.value }), errormsg: '',
                    options: [
                        { value: '', label: 'Select Bank Name' },
                        ...Bank.map(item => ({ value: item.bank_id, label: item.bank_name }))
                    ],
                },
                { size: { lg: 3 }, label: 'IFSC Code', type: 'text', name: 'bank_branch_ifsc_code', id: 'ifscCode', placeholder: 'Enter IFSC code...', value: inputData.bank_branch_ifsc_code, onChange: e => setInputData({ ...inputData, bank_branch_ifsc_code: e.target.value }), errormsg: '', },
                { size: { lg: 5 }, label: 'Account Number', type: 'number', name: 'bank_account_number', id: 'accountNumber', placeholder: 'Enter account number...', value: inputData.bank_account_number, onChange: e => setInputData({ ...inputData, bank_account_number: e.target.value }), errormsg: '', },
            ]
        },
    ];
    const Buttons = [
        { variant: "primary", text: "Save Changes", onClick: handleSaveChanges },
        { variant: "secondary", text: "Close", onClick: handleCloseModal },
    ]

    return (
        <>
            <div className='d-flex justify-content-between align-items-center mb-3'>
                <Card.Title className='mb-0'>{comapnyName}</Card.Title>
                <div>
                    <Button variant="soft-info p-0 me-3" onClick={handleVdEdit} disabled={!selectedCustomerId} >
                        <div className='avatar avatar-sm'>
                            <Icon path={mdiSquareEditOutline} className='avatar-icon' />
                        </div>
                    </Button>
                    <Button variant="soft-danger p-0" onClick={() => handleDeleteVendorEntry(selectedCustomerId)} disabled={!selectedCustomerId}>
                        <div className='avatar avatar-sm'>
                            <Icon path={mdiTrashCanOutline} className='avatar-icon' />
                        </div>
                    </Button>
                </div>
            </div>

            <Table responsive className='table-lg border table-nowrap'>
                <tbody className='table-details-list'>
                    <tr>
                        <th>Contact Person Name :</th>
                        <td>{contactPerson}</td>
                        <th>Mobile Number :</th>
                        <td>{mobileNo}
                            {/* <Button variant="link text-muted p-0" onClick={() => setPhoneShow(true)}>
                                <Icon path={mdiPhoneInTalk} className='icon-size-16' />
                            </Button>
                            <Button variant="link text-muted p-0" onClick={() => setMsgShow(true)}>
                                <Icon path={mdiMessageProcessing} className='icon-size-16' />
                            </Button> */}
                        </td>
                    </tr>
                    <tr>
                        <th>Email :</th>
                        <td>{email}
                            {/* <Button variant="link text-muted p-0" onClick={() => setEmailShow(true)}>
                                <Icon path={mdiEmail} className='icon-size-16' />
                            </Button> */}
                        </td>
                        <th>Website :</th>
                        <td>{website}</td>
                    </tr>
                    <tr>
                        <th>Address :</th>
                        <td>{address}</td>
                        <th>Country :</th>
                        <td>{Country}</td>
                    </tr>
                    <tr>
                        <th>State :</th>
                        <td>{stateName}</td>
                        <th>City :</th>
                        <td>{cityName}</td>
                    </tr>
                    <tr>
                        <th>Tax :</th>
                        <td>{taxName}</td>
                        <th>GSTIN :</th>
                        <td>{gst}</td>
                    </tr>
                    <tr>
                        <th>PAN :</th>
                        <td>{pan}</td>
                        <th>Opening Balance :</th>
                        <td>{openingBalance}</td>
                    </tr>
                    <tr>
                        <th>Vendor Tax :</th>
                        <td>{vendorTax}</td>
                        <th>Tax Type :</th>
                        <td>{vendorTaxType}</td>
                    </tr>
                    <tr>
                        <th>Date Create :</th>
                        <td>{created_date}</td>
                        <th>Alternate Number :</th>
                        <td>{Alternate}</td>
                    </tr>
                    <tr>
                        <th>Bank Name :</th>
                        <td>{bank}</td>
                        <th>IFSC Code :</th>
                        <td>{IFSC}</td>
                    </tr>
                    <tr>
                        <th>Account Number :</th>
                        <td>{AccNo}</td>
                        <th>Current balance :</th>
                        <td>N/A</td>
                    </tr>
                </tbody>
            </Table>

            {/* Phone Modal */}
            <Modal show={phoneShow} onHide={() => setPhoneShow(false)} centered>
                <Modal.Header className='custom-close-btn' closeButton></Modal.Header>
                <Modal.Body className='text-center'>
                    <div className='avatar avatar-xxxl bg-soft-success mx-auto text-success mx-auto rounded-circle mx-auto mt-4'>
                        <Icon path={mdiPhoneInTalk} className='avatar-icon' />
                    </div>
                    <h5 className='mt-4'>{mobileNo}</h5>
                </Modal.Body>
                <Modal.Footer className='mb-4'>
                    <Button variant="success mx-auto">
                        Call Now
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Phone Modal */}
            <Modal show={msgShow} onHide={() => setMsgShow(false)} centered>
                <Modal.Header className='custom-close-btn' closeButton></Modal.Header>
                <Modal.Body className='text-center'>
                    <div className='avatar avatar-xxxl bg-soft-primary mx-auto text-primary mx-auto rounded-circle mx-auto mt-4'>
                        <Icon path={mdiMessageProcessing} className='avatar-icon' />
                    </div>
                    <h5 className='mt-4'>{mobileNo}</h5>
                </Modal.Body>
                <Modal.Footer className='mb-4'>
                    <Button variant="primary mx-auto">
                        Message Send
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Email Modal */}
            <Modal show={emailShow} onHide={() => setEmailShow(false)} centered>
                <Modal.Header className='custom-close-btn' closeButton></Modal.Header>
                <Modal.Body className='text-center'>
                    <div className='avatar avatar-xxxl bg-soft-info mx-auto text-info mx-auto rounded-circle mx-auto mt-4'>
                        <Icon path={mdiEmail} className='avatar-icon' />
                    </div>
                    <h5 className='mt-4'>{email}</h5>
                </Modal.Body>
                <Modal.Footer className='mb-4'>
                    <Button variant="info mx-auto">
                        Email Send
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* From Modal */}
            <FormModal title="Edit Vendor" formModalShow={formModalShow} Buttons={Buttons} handleFormModalClose={handleFormModalClose} rows={rows} handleInputChange={handleInputChange} handleSubmit={handleSubmit} />
        </>
    )
}
